import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552c4bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("匹配")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("批量删除")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean grayRow" }, "发票没有", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean blueRow" }, "金额不一致", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean yellowRow" }, "匹配成功", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean greenRow" }, "状态为空", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'
type AuthorityRow = {
  id: number
  amount: number
  invoiceCode: string
  invoiceNo: string
  status: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/invoice_tax_bureau/query': fetchList,
  // 税务局发票_导入
  'POST/invoice_tax_bureau/upload': uploadApi,
  // 税务局发票_批量删除
  'DELETE/invoice_tax_bureau/delete': deleteApi,
  // 税务局发票_匹配
  'POST/invoice_tax_bureau/match': matchApi,
} = Api;

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const tableEle = ref()
let seleRows: Ref<AuthorityRow[]> = ref([])


const searchHandle = () => {
  fetchData({
    query: {}
  })
}
searchHandle()

// 删除
const delHandle = (row: AuthorityRow) => {
  ElMessageBox.confirm('请确认是否删除', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return deleteApi({ids: [row.id]})
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('删除成功')
    searchHandle()
  }).catch(() => {
    MI_identify.value = false
  })
}

// 批量删除
const batchDelHandle = () => {
  ElMessageBox.confirm('请确认是否批量删除', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return deleteApi({ids: seleRows.value.map(e => e.id)})
  }).then(() => {
    ElMessage.success('删除成功')
    MI_identify.value = false
    searchHandle()
  }).catch(() => {
    MI_identify.value = false
  })
}

// 匹配
const matchHandle = () => {
  ElMessageBox.confirm('请确认是否匹配', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return matchApi({ids: seleRows.value.map(e => e.id)})
  }).then(() => {
    ElMessage.success('匹配成功')
    MI_identify.value = false
    searchHandle()
    tableEle.value.clearSelection()
  }).catch(() => {
    MI_identify.value = false
  })
}

// ----------------
const rowColorFormat = ({row}: {row: AuthorityRow}) => {
  if(row.status === '发票没有'){
    return 'grayRow'
  }
  if(row.status === '金额不一致'){
    return 'blueRow'
  }
  if(row.status === '匹配成功'){
    return 'yellowRow'
  }
  if(!row.status){
    return 'greenRow'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (matchHandle())),
      disabled: _unref(seleRows).length === 0 || _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_TheUpBtn, {
      showBtn: true,
      upText: '导入税务局发票',
      upFetch: _unref(uploadApi),
      upParams: {},
      onUpSuccess: _cache[1] || (_cache[1] = ($event: any) => (searchHandle()))
    }, null, 8, ["upFetch"]),
    _createVNode(_component_el_button, {
      type: "danger",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (batchDelHandle())),
      disabled: _unref(seleRows).length === 0 || _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      icon: "refresh",
      type: "info",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle())),
      disabled: _unref(MI_identify)
    }, null, 8, ["disabled"]),
    _createVNode(_component_el_popover, {
      placement: "bottom",
      width: 400,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "ml-10",
          plain: ""
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "tableEle",
      ref: tableEle,
      border: "",
      data: _unref(MI_tableData),
      style: {"width":"1000px"},
      "row-key": "id",
      onSelectionChange: _cache[4] || (_cache[4] = (rows) => _isRef(seleRows) //@ts-ignore
 ? seleRows.value = rows : seleRows = rows),
      "row-class-name": rowColorFormat,
      "max-height": _unref(MI_height) - 50 + "px",
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          "reserve-selection": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "发票代码",
          prop: "invoiceCode"
        }),
        _createVNode(_component_el_table_column, {
          label: "发票号码",
          prop: "invoiceNo"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      class: "mt-10",
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      style: {"float":"none"},
      "page-sizes": [30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})